<template lang="pug">
div.btn(
  :class="{'disabled': disabled}"
  :style="{width: width + 'px', height: height + 'px', 'line-height': height - 25 + 'px'}"
  @click="handleClick"
)
  slot
</template>

<script type="text/javascript">
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        width: [String, Number],
        height: [String, Number]
    },
    methods: {
        handleClick () {
            if (!this.disabled) {
                this.$emit('click')
            }
        }
    }
}
</script>

<style type="text/css" lang="sass" scoped>
.btn
    cursor: pointer
    width: 360px
    height: 50px
    background: $main-gradient
    border-radius: 4px
    color: #fff
    font-size: 16px
    line-height: 25px
    margin: 0 auto
    padding: 13px 0 12px
    text-align: center
    &.disabled
        background: #D4D4D4
        cursor: default
</style>
